import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import {Category, PriceLevel} from "../models"
import * as ui from "../models/ui"
import { UnsafeAction } from "./UnsafeAction"





@Injectable()
export class PriceLevelActions {
	static LOAD_PRICE_LEVEL = '[Pricelevel] Load Pricelevel'

	static LOAD_PRICE_LEVEL_SUCCESS = '[Priceleve] Load Pricelevel Success'
	loadPriceLevelsSuccess(combinedPriceLevel:ui.CombinedPriceLevel[]): UnsafeAction{
		return {
			type: PriceLevelActions.LOAD_PRICE_LEVEL_SUCCESS,
			payload:combinedPriceLevel
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/actions/pricelevel.actions.ts